var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveUsersCount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.778,
    height: 27.778,
    viewBox: "0 0 27.778 27.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.271 22.518h-.243a2.315 2.315 0 0 1-2.037-1.829l-3.1-14.375-3.196 7.407a1.157 1.157 0 0 1-1.065.694H3.157a1.157 1.157 0 0 1 0-2.315h2.709l2.905-6.7a2.315 2.315 0 0 1 4.387.44L16.26 20.2l3.195-7.384a1.157 1.157 0 0 1 1.065-.718h3.472a1.157 1.157 0 1 1 0 2.315h-2.709l-2.905 6.7a2.315 2.315 0 0 1-2.107 1.405z",
    transform: "translate(0.315 0.631)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveUsersCount);
export default __webpack_public_path__ + "static/media/liveUsersCount.f501ebc7b6bce8dc5d50baaa93ba5842.svg";
export { ForwardRef as ReactComponent };